import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { findBySala, save, attachFile, downloadFile, existsSalaMensagemLast, marcarComoNaoLida } from "./api-sala-mensagem";
import Grid from '@mui/material/Grid';
import { dateTimeFormat } from "../../../util/DateUtil";
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link, useLocation } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import EmojiPicker from 'emoji-picker-react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../UI/Loading';
import { ADMIN } from '../../Usuario/Perfil';
import SMMenuOptions from './SMMenuOptions';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { green } from '@mui/material/colors';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Mensagem from './Mensagem';
import PictureAttach from './PictureAttach';
import AttachFile from './AttachFile';
import FormSendMessage from './FormSendMessage';
import { createAndDownloadBlobFile } from '../../../util/DownloadUtil';
import { errorMessage } from '../../../util/ConfirmAlertUtil';
import { Paper } from '@mui/material';
import { toast } from 'react-toastify';
import { setQuantNaoLidas } from '../SalaParticipante/actions/actions';

const useStyles = makeStyles({
    container: {
        marginTop: '8px',
        marginBottom: '8px',
        paddingTop: '8px',
        paddingBottom: '8px'
    },
    boxMessages: {
        display: 'flex',
        flexDirection: 'column-reverse',
        backgroundColor: "azure",
        padding: '20px',
        borderRadius: '20px',
    },
    boxCurrentUser: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginBottom: '10px',
    },
    boxOtherUser: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginBottom: '10px',
    },
    itemCurrentUser: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginTop: '5',
        marginBottom: '5',
        backgroundColor: '#98FB98',
        paddingTop: 15,
        paddingBottom: 15,
        paddingLeft: 25,
        paddingRight: 25,
        borderRadius: 50,
    },
    itemOtherUser: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginVertical: 5,
        backgroundColor: '#fff',
        paddingTop: 15,
        paddingBottom: 15,
        paddingLeft: 25,
        paddingRight: 25,
        borderRadius: 50,
    },
    loading: {
        marginTop: '20px',
    },

    sendBtn: {
        marginTop: '20px',
        marginBottom: '15px',
        marginLeft: '10px',
    },
    menuIcon: {
        cursor: 'pointer',
    },
    fotoComponent: {
        maxHeight: '100px',
        borderRadius: '100%',
    },
});

export default function SalaMensagem() {
    const classes = useStyles();
    const location = useLocation();
    const [salaParticipante, setSalaParticipante] = useState(location.state.salaParticipante ? location.state.salaParticipante : { sala: location.state.sala });
    const [nameRoom] = useState(location.state.nameRoom);
    const isAll = useSelector(state => state.isAllMensagemTable);
    const [isLoading, setIsLoading] = useState(true);
    const [listSMSelect, setListSMSelect] = useState([]);
    const [salaMensagens, setSalaMensagens] = useState({
        content: [],
        totalElements: 0,
        number: 0,
        numberOfElements: 0
    });
    const [mensagem, setMensagem] = useState('');
    const user = useSelector(state => state.usuario);
    const [isSending, setIsSending] = useState(false);
    const [isAttachingFile, setIsAttachingFile] = useState(false);
    const hiddenFileInput = useRef(null);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const messagesEndRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState();
    const quantNaoLidas = useSelector(state => state.quantNaoLidas);
    const dispatch = useDispatch();

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, []);


    const fetchData = () => {
        if (salaParticipante.sala.codigo) {
            setIsLoading(true);
            findBySala(salaParticipante.sala.codigo, 0).then((data) => {
                if (data) {
                    if (data.error) {
                        errorMessage(data.message);
                    } else {
                        setSalaMensagens(data);
                    }
                }
                setIsLoading(false);
            })
        }
    }


    /**
     *  Método antigo que sempre buscava todas as ultimas 10 mensagens para conferir se tinha mensagem nova
     *  foi substituido por um retorno booleano se a ultima mensagem no cliente é a ultima mensagem no servidor.
     */
    // useEffect(() => {
    //     const findNewMessages = setInterval(() => {
    //         findBySala(salaParticipante.sala.codigo, 0).then((data) => {
    //             if (data) {
    //                 if (salaMensagens.content.length > 0) {

    //                     let index = data.content.findIndex(d => d.codigo === salaMensagens.content[0].codigo);
    //                     if (index === 0) {
    //                         return;
    //                     }
    //                     for (
    //                         let i = index - 1;
    //                         i >= 0;
    //                         i--
    //                     ) {
    //                         setSalaMensagens(prevState => ({
    //                             ...prevState,
    //                             content: [
    //                                 data.content[i],
    //                                 ...prevState.content
    //                             ]
    //                         }))
    //                     }
    //                 }
    //             }
    //         })
    //     }, 10000);
    //     return () => clearInterval(findNewMessages);

    // }, [salaMensagens.content, salaParticipante.sala.codigo]);

    useEffect(() => {
        const findNewMessages = setInterval(() => {
            if (salaMensagens.content.length > 0) {
                existsSalaMensagemLast(salaParticipante.sala.codigo, salaMensagens.content[0].codigo).then((data) => {
                    if (!data) {
                        fetchData();
                    }
                })
            }

        }, 40000);
        return () => clearInterval(findNewMessages);
        // eslint-disable-next-line
    }, [salaMensagens.content, salaParticipante.sala.codigo]);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleChange = (event) => {
        setMensagem(event.target.value);
    }

    const handleSend = (event) => {
        event.preventDefault();
        if (mensagem.length === 0) {
            return;
        }
        setIsSending(true);
        let salaMensagem = {
            sala: salaParticipante.sala,
            mensagem: mensagem
        }
        save(salaMensagem).then((data) => {
            if (!data || data.error) {
                console.log(data);
            } else {
                setSalaMensagens({
                    ...salaMensagens,
                    content: [
                        data,
                        ...salaMensagens.content
                    ]
                })
                setMensagem('');
                setSalaParticipante({
                    ...salaParticipante,
                    quantNaoLidasOtherUser: salaParticipante.quantNaoLidasOtherUser + 1
                })
            }
            setIsSending(false);
        })
    }

    const handleEmojiShow = () => {
        setShowEmojiPicker(!showEmojiPicker);

        setTimeout(() => messagesEndRef.current.scrollIntoView({ behavior: "smooth" }), 5);


    }

    const handleMoreMesssages = () => {
        findBySala(salaParticipante.sala.codigo, salaMensagens.number + 1).then((data) => {
            if (data) {
                setSalaMensagens({
                    ...data,
                    content: [
                        ...salaMensagens.content,
                        ...data.content,
                    ]
                });
            }
            setIsLoading(false);
        })
    }

    const handleAttachFile = () => {
        hiddenFileInput.current.click();
    }


    const handleChangeFile = event => {
        const file = event.target.files[0];

        if (file === null) {
            return;
        }

        const fileFormData = new FormData();
        fileFormData.append('file', file);
        setIsAttachingFile(true);
        attachFile(salaParticipante.sala.codigo, fileFormData).then((data) => {
            if (data.error) {
                console.log(data.error);
            } else {
                setSalaMensagens({
                    ...salaMensagens,
                    content: [
                        data,
                        ...salaMensagens.content
                    ]
                })
                setMensagem('');
            }
            setIsAttachingFile(false);
        })

    };

    const onEmojiClick = (emojiData, event) => {
        setMensagem((prevState) => prevState + emojiData.emoji);
    };

    const handleSMSelect = (sm) => {
        if (user.perfil === ADMIN) {
            const exist = listSMSelect.find(smSelect => smSelect.codigo === sm.codigo);
            if (!exist) {
                setListSMSelect([
                    ...listSMSelect,
                    sm
                ]);
            }
        }

    }

    const handleDownloadAttach = (sm) => {
        downloadFile(sm.codigo, sm.fileName, sm.fileType).then((data) => {
            console.log(data);
            if (data.error) {
                errorMessage(data.message);
            } else {
                createAndDownloadBlobFile(data, sm.fileName);

            }
        })
    }

    const handleMarcarComoNaoLida = () => {
        marcarComoNaoLida(salaParticipante.sala.codigo);
        dispatch(setQuantNaoLidas(quantNaoLidas + 1));
        toast.success("Mensagem marcada como não lida.", {
            position: 'bottom-left'
        });
    }


    return (
        <Container className={classes.container} component={Paper}>
            <Grid container direction='column' spacing={1}>
                <Grid>
                    <Grid
                        container
                        direction='row'
                        alignItems='center'
                        justifyContent="space-between"
                    >
                        <Grid>
                            <Grid
                                container
                                alignItems='center'
                                direction='row'
                                spacing={3}
                            >
                                <Grid>
                                    <Button
                                        component={Link}
                                        to={{
                                            pathname: '/mensagem'
                                        }}
                                        variant="outlined"
                                    >
                                        <ArrowBackIcon style={{ marginRight: '10px' }} />
                                    </Button>
                                </Grid>
                                {salaParticipante && !salaParticipante.sala.isGroup ?
                                    <>
                                        {salaParticipante.usuario && salaParticipante.usuario.fileName ?
                                            <Grid>
                                                <img
                                                    src={salaParticipante.usuario.fotoUrl}
                                                    className={classes.fotoComponent}
                                                    alt=''
                                                />
                                            </Grid> : ''
                                        }
                                    </>
                                    :
                                    ''
                                }
                                <Grid>
                                    <Typography variant="h6">
                                        {nameRoom}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid>

                            {
                                user && user.perfil && (user.perfil === 'ADMIN' ||
                                    user.perfil === 'COORDERNADOR' ||
                                    user.perfil === 'PROFESSOR')
                                    ?
                                    <>
                                        <MenuIcon
                                            className={classes.menuIcon}
                                            onClick={(event) => handleMenuClick(event)}
                                            color="secondary"

                                        />
                                        <Menu
                                            id="simple-menu"
                                            anchorEl={anchorEl}
                                            keepMounted
                                            open={Boolean(anchorEl)}
                                            onClose={handleMenuClose}
                                        >
                                            <MenuItem
                                                component={Link}
                                                to={{
                                                    pathname: '/group-list-participants',

                                                }}
                                                state={{
                                                    sala: salaParticipante.sala
                                                }}
                                            >
                                                Lista Participantes
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => handleMarcarComoNaoLida()}
                                            >
                                                Marcar como não lida
                                            </MenuItem>
                                        </Menu>
                                    </>

                                    : ''
                            }


                        </Grid>

                    </Grid>
                </Grid>

                <Grid>
                    <Grid container alignItems='center' direction='row' spacing={3}>

                    </Grid>
                </Grid>
                <Grid>
                    {isLoading ?
                        <Loading description='Carregando Mensagens...' />
                        :
                        <>

                            <SMMenuOptions
                                listSMSelect={listSMSelect}
                                setListSMSelect={setListSMSelect}
                                setSalaMensagens={setSalaMensagens}
                            />
                            <div className={classes.boxMessages} >
                                {salaMensagens.content.length > 0 && salaMensagens.content[0].usuario.id === user.id ?
                                    <>
                                        {salaParticipante.quantNaoLidasOtherUser === 0 ? 'Visualizado' : 'Não Visualizado'}
                                    </> : ''
                                }

                                {user ?
                                    salaMensagens.content.map((sm, i) => (
                                        <div
                                            className={sm.usuario.id === user.id ? classes.boxCurrentUser : classes.boxOtherUser}
                                            key={i}
                                            onClick={() => handleSMSelect(sm)}
                                        >


                                            <div
                                                className={sm.usuario.id === user.id ? classes.itemCurrentUser : classes.itemOtherUser}
                                            >

                                                {(salaParticipante.sala.isGroup || isAll) && sm.usuario.id !== user.id ?
                                                    <div style={{ fontSize: 12 }}>{sm.usuario.nome}</div> :
                                                    ''
                                                }
                                                <Mensagem
                                                    sm={sm}
                                                />

                                                <PictureAttach
                                                    sm={sm}
                                                />
                                                <AttachFile
                                                    sm={sm}
                                                    handleDownloadAttach={handleDownloadAttach}
                                                />

                                                <div style={{ fontSize: 8 }}>{dateTimeFormat(sm.createdAt)}</div>
                                                {listSMSelect.length > 0 && listSMSelect.find(smSelect => smSelect.codigo === sm.codigo) && <CheckCircle style={{ color: green[500] }} />}

                                            </div>
                                        </div>
                                    ))
                                    : ''
                                }
                                {(salaMensagens.totalPages - 1) > salaMensagens.pageable.pageNumber ?
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        marginBottom: '20px'
                                    }} >
                                        <RefreshIcon
                                            onClick={handleMoreMesssages}
                                            fontSize="small"
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </div> : ''
                                }

                            </div>
                            {showEmojiPicker && <EmojiPicker pickerStyle={{ width: '100%' }} onEmojiClick={onEmojiClick} />}

                            <FormSendMessage
                                handleSend={handleSend}
                                handleEmojiShow={handleEmojiShow}
                                mensagem={mensagem}
                                handleChange={handleChange}
                                hiddenFileInput={hiddenFileInput}
                                handleChangeFile={handleChangeFile}
                                isAttachingFile={isAttachingFile}
                                handleAttachFile={handleAttachFile}
                                isSending={isSending}
                            />
                            <div ref={messagesEndRef} />
                        </>
                    }
                </Grid>
            </Grid>
        </Container>
    );
}